import { useEffect, useRef, useState } from 'react';
import AdSenseBanner from '../components/AdSenseBanner';

// Free-tier upload gate: every upload shows an ad while a progress bar fills.
// A single file waits BASE_MS; each extra file adds PER_FILE_MS (capped), so a
// multi-file batch gets a noticeably slower bar. The ad stays on screen while
// the files are actually processed, and the gate closes only when both the
// bar has finished and processing is done.
export const AD_GATE_BASE_MS = 5000;
export const AD_GATE_PER_FILE_MS = 1500;
export const AD_GATE_MAX_MS = 30000;

export function adGateDuration(fileCount) {
  return Math.min(AD_GATE_MAX_MS, AD_GATE_BASE_MS + Math.max(0, fileCount - 1) * AD_GATE_PER_FILE_MS);
}

export default function AdGate({ fileCount, phase, onWaitDone }) {
  const [progress, setProgress] = useState(0);
  const doneRef = useRef(onWaitDone);
  doneRef.current = onWaitDone;
  const duration = adGateDuration(fileCount);

  useEffect(() => {
    const start = performance.now();
    let raf;
    const tick = (now) => {
      const p = Math.min(1, (now - start) / duration);
      setProgress(p);
      if (p < 1) raf = requestAnimationFrame(tick);
      else doneRef.current();
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [duration]);

  const pct = Math.round(progress * 100);
  const label = phase === 'processing'
    ? 'Procesando tus archivos…'
    : `Preparando ${fileCount} archivo${fileCount !== 1 ? 's' : ''}…`;

  return (
    <div data-testid="ad-gate" role="dialog" aria-modal="true"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-2xl p-6 space-y-4">
        <h3 className="font-semibold text-gray-800">{label}</h3>
        <div className="h-3 w-full bg-gray-200 rounded-full overflow-hidden">
          <div data-testid="ad-gate-bar" className="h-full bg-brand-600 transition-none" style={{ width: `${pct}%` }} />
        </div>
        <p data-testid="ad-gate-pct" className="text-xs text-gray-500">{pct}% · Publicidad — ayuda a mantener gratis esta herramienta</p>
        <AdSenseBanner slot="7397489309" />
      </div>
    </div>
  );
}
